import React from "react";
import { Button } from "react-bootstrap";

import "./borderButton.css";

const BorderButton = ({ value, className, onClick, disabled, style }) => {
  return (
    <div className="border-btn">
      <Button
        className={`button-box ${className}`}
        onClick={onClick}
        disabled={disabled}
        style={style}
      >
        {value}
      </Button>
    </div>
  );
};

export default BorderButton;
